export default "__VITE_ASSET__B5Ca2R23__"